import { features } from '@/mocks/homepage';

export default function Features() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            专业、全面、及时的体育服务平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 group hover:border-accent-300 transition-all duration-200 cursor-default"
            >
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 transition-colors ${
                index === 0 ? 'bg-primary-100 text-primary-600' :
                index === 1 ? 'bg-accent-100 text-accent-700' :
                index === 2 ? 'bg-secondary-100 text-secondary-600' :
                'bg-primary-100 text-primary-600'
              }`}>
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2 tracking-wide">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}